import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import AuthContext from '../../context/AuthContext';

// This component ensures that only artist accounts can access certain routes
const ArtistRoute = () => {
  const { user, loading } = useContext(AuthContext);
  
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Check if user is logged in and has artist account type
  if (!user) {
    return <Navigate to="/login" replace />;
  } else if (user.accountType === 'curator' && !user.isArtist) {
    // If this is a curator account (not an artist), redirect to the home page
    return <Navigate to="/" replace />;
  }
  
  return <Outlet />;
};

export default ArtistRoute;